<template>
  <Layout>
    <!-- <language-switch class="lang" /> -->
    <form @submit.prevent>
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-5">
          <div class="card overflow-hidden">
            <div class="bg-soft-primary">
              <div class="row">
                <div class="col-7">
                  <div class="text-primary p-4">
                    <h3 class="text-dark">TuneSoft</h3>
                    <h5 class="text-primary">
                      {{ $t("account.find-your-account") }}
                    </h5>
                  </div>
                </div>
                <div class="col-5 align-self-end">
                  <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div>
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img :src="whiteLabel || require('@/assets/images/logo-small.png')" :class="['rounded-circle', whiteLabel ? 'w-100 h-100' : '']" height="60" />
                  </span>
                </div>
              </div>
              <div class="p-2">
                <p class="text-muted" v-html="$t('account.forgot-password-description')"></p>
                <div>
                  <sweet-input
                    :isValid="!$v.form.email.$error"
                    @input="$v.form.email.$touch()"
                    v-model="form.email"
                    type="email"
                    layout="vertical"
                    inputClass="mt"
                    :placeholder="$t('auth.placeholder.email')"
                    :label="$t('common.email')"
                    :disabled="!!account"
                  />
                </div>

                <br />

                <div v-if="enableRecaptcha">
                  <vue-recaptcha ref="recaptcha" @verify="handleRecaptchaVerify" :sitekey="recaptchaKey" size="invisible"> </vue-recaptcha>
                  <b-button type="submit" variant="primary" class="btn-block" @click="resetPassword" :disabled="$v.form.$invalid || isRequesting">
                    {{ $t("common.send-email") }}
                  </b-button>
                </div>

                <div v-else>
                  <b-button type="submit" variant="primary" class="btn-block" @click="resetPassword" :disabled="$v.form.$invalid || isRequesting">
                    {{ $t("common.send-email") }}
                  </b-button>
                </div>
              </div>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->

          <div class="mt-5 text-center">
            <p>
              <a href="/login" class="font-weight-medium text-primary">
                <i class="bx bx-lock font-size-30 align-middle"></i>
                {{ $t("common.login") }}
              </a>
            </p>
            <p>© {{ new Date().getFullYear() }} Tunesoft</p>
          </div>

          <!-- TKP-236 n.11: "powered by Phexum" kalktı -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </form>
  </Layout>
</template>

<script>
import Layout from "@/layouts/account/auth";
import { VueRecaptcha } from "vue-recaptcha";

import { email, maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  components: { Layout, VueRecaptcha },
  data() {
    return {
      form: { email: undefined, required: undefined },
      formError: undefined,
      isRequesting: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(40),
        email,
      },
    },
  },
  computed: {
    account() {
      return this.$store.getters["user/account"];
    },
    recaptchaKey() {
      return this.$store.getters["clientConfig/recaptchaKey"];
    },
    enableRecaptcha() {
      return this.$store.getters["clientConfig/enableRecaptcha"];
    },
  },

  mounted() {
    if (this.account) {
      this.form.email = this.account.credential.email;
    }
  },

  methods: {
    async resetPassword() {
      if (this.enableRecaptcha) {
        this.$refs.recaptcha.reset();
        this.$refs.recaptcha.execute();
      } else {
        await this.submit();
      }
    },
    async submit() {
      if (this.isRequesting) {
        return;
      }
      this.isRequesting = true;

      const response = await this.$store.dispatch("user/resetPassword", this.form);

      this.$toast.success(this.$t("common.sent-email"));

      setTimeout(() => {
        this.isRequesting = false;
        window.history.back();
      }, 2000);
    },
    async handleRecaptchaVerify(response) {
      if (response) {
        try {
          await this.submit();
        } catch (error) {
          console.error("Form submission error", error);
        }
      }
    },
  },
};
</script>
<style scoped>
.lang {
  position: absolute;
  top: 0;
  right: 1rem;
}
</style>
